import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";
import { first } from "lodash-es";
import { Observable, defer, forkJoin, iif, map, of, switchMap } from "rxjs";
import { InvoiceBackend } from "src/app/backend/api/invoice.backend";
import { Book } from "src/app/backend/models/book/book";
import { BookItem } from "src/app/backend/models/book/book-item";
import { environment } from "src/environments/environment";

@Injectable()
export class BookItemBackend {
  private readonly http = inject(HttpClient);
  private readonly invoiceBackend = inject(InvoiceBackend);

  load({
    patientiId,
    itemId
  }: {
    patientiId: string;
    itemId: string;
  }): Observable<BookItem | undefined> {
    return this.loadSingle(patientiId).pipe(
      map((book) => book?.items.find((x) => x.id === itemId))
    );
  }

  private loadSingle(patientId: string): Observable<Book | undefined> {
    return this.http
      .get<Book[]>(
        `${environment.snoots.api.billing}/patients/${patientId}/books`
      )
      .pipe(
        map((books) => first(books)),
        map((book: Book | undefined) => (book ? sortBookItems(book) : book)),
        map((book: Book | undefined) => (book ? extendBook(book) : book))
      );
  }
}

function sortBookItems(book: Book): Book {
  return {
    ...book,
    items: book.items?.sort((leftItem, rightItem) => {
      return (
        dateUtil(rightItem.createdAt).toDate().getTime() -
        dateUtil(leftItem.createdAt).toDate().getTime()
      );
    })
  };
}

function extendBook(book: Book): Book {
  return {
    ...book,
    items: book.items
      ? book.items.map((bookItem: BookItem) => {
          return {
            ...bookItem,
            invoice: bookItem.invoice
              ? {
                  ...bookItem.invoice,
                  draft: !bookItem.invoice.emittedBy
                }
              : bookItem.invoice
          };
        })
      : book.items
  };
}
